import { PageContentQueryResponseDto } from 'enrollment/queries/usePageContentQuery/types';

export const PAGE_CONTENT_LOOKUP_CODE: {
  [key: string]: string;
} = {
  ENROLL_COVERAGE: 'enroll_coverage',
  ENROLL_PCP: 'enroll_pcp',
  ENROLL_CONFIRM_EMAIL: 'enroll_confirm_email',
  ENROLL_CONFIRM: 'enroll_confirm',
  ENROLL_BENEFICIARY: 'enroll_beneficiary',
  ENROLL_BENEFITS: 'enroll_benefits',
  ENROLL_DEPENDENTS: 'enroll_dependents',
  ENROLL_DEPENDENTS_NEW: 'enroll_dependents/new',
  ENROLL_DEPENDENTS_EDIT: 'enroll_dependents/edit',
  ENROLL_PERSONAL: 'enroll_personal',
  ENROLL_PERSONAL_VIEW: 'enroll_personal_view',
  SUB_MAIN: 'sub_main',
  SUB_MAIN_NEW_MESSAGE: 'sub_main/new_message',
  SUB_MAIN_CONFIRM: 'sub_main/confirm',
  DASHBOARD: 'dashboard',
  LIFE_EVENT: 'sub/enroll_life_event',
};

export const hasRequiredPageContent = (
  pc: PageContentQueryResponseDto | undefined
) => {
  // all fields are optional so we can assert
  // if any one is present then there exists required page content
  return (
    pc &&
    pc.data.required_page_content &&
    pc.data.required_page_content.content_blocks &&
    (pc.data.required_page_content.page_text ||
      pc.data.required_page_content.page_title ||
      pc.data.required_page_content.page_subtitle ||
      pc.data.required_page_content.content_blocks)
  );
};

export const hasContentBlocks = (
  pc: PageContentQueryResponseDto | undefined
) => {
  return pc && pc.data.content_blocks && pc.data.content_blocks.length > 0;
};
